import React from 'react'
import Recent from './Components/Recent'
import Mode from './Components/Mode'
import Principle from './Components/Principle'
import Mission from './Components/Mission'


function Main() {
  return (
    <>
<div className="grid sm:grid-cols-1 md:grid-rows-5 md:grid-cols-2 gap-4  lg:gap-6 text-center m-4 select-none">
    <Recent/>
    <Mode/>
    <Mission/>
    <Principle/>
</div>

    </>
  )
}

export default Main;